import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { isNilOrEmpty } from "../../../../../legacy/utils/dataUtils";
import { TAXONOMY_CLIENT } from "../../../../../utils/consts";
import { PRODUCT_ID_QUERY } from "../../../../../apis/taxonomy/queries";
import { HgProduct, ProductsQueryPayload } from "../../../../../types/taxonomy";

interface ProductByIds {
  loading: boolean;
  matchedProductsById: HgProduct[];
  categoryNameTree: string[];
  productsNameMapById: Record<number, string>;
}

export default function useMatchProductsById(ids: number[]): ProductByIds {
  const { data, loading } = useQuery<ProductsQueryPayload, { ids: number[] }>(
    PRODUCT_ID_QUERY,
    {
      variables: {
        ids,
      },
      skip: isNilOrEmpty(ids),
      context: {
        clientName: TAXONOMY_CLIENT,
      },
    }
  );

  const matchedProductsById = useMemo(() => data?.product?.data || [], [data]);

  const categoryNameTree = useMemo(
    () =>
      (matchedProductsById && matchedProductsById[0]?.category?.nameTree) || [],
    [matchedProductsById]
  );

  const productsNameMapById = useMemo(() => {
    const map = {} as Record<number, string>;

    for (const { id, name } of matchedProductsById) {
      map[id] = name;
    }

    return map;
  }, [matchedProductsById]);

  return {
    loading,
    matchedProductsById,
    categoryNameTree,
    productsNameMapById,
  };
}
